import React from 'react';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HomeIcon from '@mui/icons-material/Home';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

export const stepTitle = '';
export const stepDescription = '';

const steps = [
  {
    number: 1,
    icon: <HomeIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
    title: 'Start with the basics',
    description: 'Add the property address, type, rent amount, and lease term.',
  },
  {
    number: 2,
    icon: <CameraAltIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
    title: 'Make it stand out',
    description:
      'Bring your listing to life with photos, a list of amenities, and a standout description.',
  },
  {
    number: 3,
    icon: <CheckCircleIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
    title: 'Go live',
    description:
      'Get your listing on other top sites, set your screening requirements, and publish.',
  },
];

const IntroductionStep: React.FC = () => (
  <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        minHeight: 500,
        width: '100%',
        maxWidth: 1100,
        gap: 32,
        padding: '32px 0',
      }}
      className='md:flex-row mx-auto'
    >
      {/* Left: Big headline */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          width: '50%',
          minHeight: 300,
          marginRight: 32,
        }}
      >
        <Typography
          variant='h3'
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '3rem' },
            lineHeight: 1.1,
          }}
          className='text-gray-900 max-w-lg text-left'
        >
          List your property in 3 simple steps.
        </Typography>
      </div>
      {/* Right: 3 step cards stacked vertically */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          maxWidth: 400,
          width: '100%',
          justifyContent: 'center',
          minHeight: 300,
        }}
      >
        {steps.map(step => (
          <div
            key={step.number}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              background: 'white',
              borderRadius: 12,
              padding: 16,
            }}
          >
            <div
              style={{
                background: 'black',
                color: 'white',
                borderRadius: '50%',
                minWidth: 48,
                width: 48,
                height: 48,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20,
                fontWeight: 700,
                marginRight: 16,
              }}
            >
              {step.number}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              {step.icon}
              <Typography
                variant='subtitle1'
                sx={{ fontWeight: 600, marginBottom: 0.5, marginTop: 1 }}
              >
                {step.title}
              </Typography>
              <Typography variant='body2' color='textSecondary'>
                {step.description}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default IntroductionStep;
